import { Modal } from "@/components/shared/Modal";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useState } from "react";

interface RefineModalProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (refinementPrompt: string) => void;
}

export const RefineModal = ({ open, onClose, onSubmit }: RefineModalProps) => {
    const [prompt, setPrompt] = useState("");

    const isValid = prompt.trim().length >= 3;

    const handleSubmit = () => {
        if (isValid) {
            onSubmit(prompt.trim());
            setPrompt("");
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" && (e.metaKey || e.ctrlKey) && isValid) {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Refine Checklist"
            subtitle="Describe how to adjust this checklist. The agent will re-evaluate topics and clauses based on your instruction."
            maxWidth="sm"
            actions={[
                {
                    label: "Refine",
                    onClick: handleSubmit,
                    variant: "contained",
                    disabled: !isValid,
                },
            ]}
        >
            <div className="grid w-full gap-1.5">
                <Label htmlFor="refinement-instructions">
                    Refinement Instructions
                </Label>
                <Textarea
                    id="refinement-instructions"
                    rows={4}
                    placeholder="e.g., 'Focus more on CGL coverage' or 'Add workers compensation clauses' or 'This is actually a contract review, not a policy review'"
                    value={prompt}
                    onChange={(e) => {
                        if (e.target.value.length <= 2000) {
                            setPrompt(e.target.value);
                        }
                    }}
                    onKeyDown={handleKeyDown}
                    autoFocus
                />
            </div>
        </Modal>
    );
};
